import ViewModelCore from "./ViewModel";

export default class PedidoDesdobramentoViewModel extends ViewModelCore{
    constructor () {
        super();
		this.EmpresaId = undefined;
		this.PedidoId = undefined;
		this.ClienteId = undefined;
		this.ClienteNome = undefined;
		this.ClienteCodigo = undefined;
		this.PedidoParcelaId = undefined;
		this.NumeroOrdemCompra = undefined;
		this.NumeroParcela = undefined;
		this.NumeroLc = undefined;
		this.CodigoOperComl = undefined;
		this.QuantidadeFaturar = undefined;	
    }
}
